/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { ErrorDefaultCodeEnum } from 'client-code/fe-fav-service';
import { ErrorTypes } from './ErrorTypes';
import { PostSignInError } from './PostSignInError';

export class DeviceFeatureSearchError extends PostSignInError {
    constructor(message: string, code: string, description: string) {
        super(code, message);
        this.description = description;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ErrorDefaultCodeEnum.ApigwError:
                this.code = ErrorTypes.DEVICE_FEATURES_SEARCH_APIGW_ERROR_C1002;
                this.type = ErrorDefaultCodeEnum.ApigwError;
                break;
            default:
                this.code = ErrorTypes.DEVICE_FEATURES_SEARCH_UNKNOWN_ERROR_C1099;
                this.type = 'DEVICE_FEATURES_SEARCH_UNKNOWN_ERROR';
        }
    }
}
